export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE'
export const SET_FIRST_PAGE = 'SET_FIRST_PAGE'
export const SET_HAS_MORE = 'SET_HAS_MORE'
export const CLEAR_LIST_PROCESING = 'CLEAR_LIST_PROCESING'
export const CLEAR_LEST = 'CLEAR_LEST'
export const SET_LOADING_BLOCK_LIST = 'SET_LOADING_BLOCK_LIST'
export const SET_ALL_PAGE = 'SET_ALL_PAGE'
export const SET_LIST_DATA_LENGTH = 'SET_LIST_DATA_LENGTH'
export const SET_SELECTED_PAGE = 'SET_SELECTED_PAGE'
